// extracted by mini-css-extract-plugin
export var copy = "styles-module--copy--KoRfH";
export var overview = "styles-module--overview--PVh5l";